import {redColor} from '../../styles/style';

const style = {
  cardContent: {
    height: '100%',
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    minHeight: '87px',
    height: '80%',
  },
  container__message: {
    margin: '25px auto',
  },
  item: {
    flexBasis: '49%',
    display: 'inline-block',
    fontWeight: '400',
    fontSize: '12px',
    textTransform: 'uppercase',
  },
  part_threat: {
    display: 'inline-block',
    width: '71%',
    textAlign: 'right',
  },
  part_count: {
    display: 'inline-block',
    width: '28%',
    textAlign: 'left',
    fontWeight: '500',
    paddingLeft: '7px',
  },
  part_count_danger: {
    color: redColor,
  },
  titleWithAction: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    cursor: 'pointer',
  },
};

export default style;
